<template>
  <div class="dollar-input">
    <input ref="input" type="text" @input="handleInput" :value="realValue" required/>
  </div>
</template>

<script>
import Cleave from 'cleave.js'
export default {
  data () {
    return {
      cleave: null
    }
  },
  computed: {
    value () {
      return this.$store.state.userData[this.dataKey]
    },
    realValue () {
      return this.value === undefined ? this.default : this.value
    }
  },
  methods: {
    handleInput (event) {
      this.$emit('input', { value: this.cleave.getRawValue() })
    }
  },
  mounted () {
    this.cleave = new Cleave(this.$refs.input, {
      numeral: true,
      numeralThousandsGroupStyle: 'thousand'
    })
  },
  props: ['options', 'data-key', 'default']
}
</script>

<style lang="scss" scoped>
.dollar-input{
  display: flex;
  border: 1px solid gray;
  border-radius: 3px;
  margin: 0 auto;
  margin-bottom: 5em;
  width: 100%;
  max-width: 300px;
  box-sizing: border-box;
  justify-content: center;

  &::before{
    content: "$";
    padding: 0.25em 0.5em;
    padding-right: 0;
    font-size: 1.5em;
    display: flex;
    align-items: center;
  }

  >input{
    margin: 0;
    padding-left: .25em;
    border: 0;
    text-align: left;

    &:focus{
      outline: none;
    }
  }
}
</style>
